/**
 * List-view click policy for the full-page calendar.
 *
 * FullCalendar turns every event into role="button" when a calendar-level
 * eventClick handler exists, unless the view sets eventInteractive: false.
 * A button around a list row nests the title link and any description links
 * (WCAG 2.1 SC 4.1.2). List views, including meal calendars, opt out and let
 * those links navigate. Grid views still open the event from the row click.
 */

export const isListView = (viewType: string): boolean => viewType.startsWith('list');

export const shouldOpenEventFromClick = (viewType: string): boolean => !isListView(viewType);
